import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import FormatUtils from '../../../utils/FormatUtils';
import { getMarkerEndpoints, getDefaultStarts } from '../../../utils/adsMarker';
import { FormattedMessage } from 'react-intl';

const SelectSilences = ({
  silenceDetected,
  handleMarkerChange,
  marker,
  currentPosition,
  markers,
  episodeDuration,
}) => {
  const markerId = marker.placement;
  const [minStart, maxStart] = getMarkerEndpoints(markers, markerId, episodeDuration);
  const silences = silenceDetected.filter(({ end }) => end > minStart && end < maxStart);

  const [selected, setSelected] = useState(currentPosition);
  useEffect(() => {
    if (currentPosition !== selected) {
      handleMarkerChange(markerId, selected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  const defaultStart = getDefaultStarts({
    episodeDuration,
    placement: marker.placement,
    silences: silenceDetected,
    markers,
  });

  return (
    <Select defaultValue={defaultStart} value={selected} onChange={(val) => setSelected(val)}>
      <Select.OptGroup label={<FormattedMessage defaultMessage="Default Position" />}>
        <Select.Option value={defaultStart} key={silenceDetected.length + 1}>
          {FormatUtils.formatTimeHundredthSeconds(defaultStart)}
        </Select.Option>
      </Select.OptGroup>

      <Select.OptGroup label={<FormattedMessage defaultMessage="Current" />}>
        <Select.Option value={currentPosition} key={silenceDetected.length + 2}>
          {FormatUtils.formatTimeHundredthSeconds(currentPosition)}
        </Select.Option>
      </Select.OptGroup>

      <Select.OptGroup label={<FormattedMessage defaultMessage="Silences" />}>
        {silences.map(({ duration, end }, key) => {
          const startAt = end - duration;
          return (
            startAt > 0 && (
              <Select.Option value={startAt} key={key}>
                {FormatUtils.formatTimeHundredthSeconds(startAt)}
              </Select.Option>
            )
          );
        })}
      </Select.OptGroup>
    </Select>
  );
};

SelectSilences.propTypes = {
  marker: PropTypes.object.isRequired,
  silenceDetected: PropTypes.array.isRequired,
  handleMarkerChange: PropTypes.func.isRequired,
  currentPosition: PropTypes.number.isRequired,
  markers: PropTypes.array.isRequired,
  episodeDuration: PropTypes.number.isRequired,
};

export default SelectSilences;
